import StageActions from './styled';

export default StageActions;
